import React, { forwardRef, ForwardRefRenderFunction, useEffect, useState } from 'react'
import AutoLocation from 'sr/helpers/ui-components/AutoLocation'
import DropDown from 'sr/helpers/ui-components/DropDown.tsx'
import { Input, TextArea } from 'sr/helpers'
import { FormattedMessage, useIntl } from 'react-intl'
import { useFormik } from 'formik'
import { AddressSchema } from 'sr/utils/schemas/individual/Address'
import { createAddress } from 'sr/utils/api/individual/address/createAddress'
import { SuccessMessage } from 'sr/helpers/functions/SuccessMessage'
import { LoaderFullScreen } from 'sr/layout/common/LoaderFullScreen'
import { updateAddress } from 'sr/utils/api/individual/address/updateAddress'
import { getUserDetails } from 'sr/helpers/functions/getUserDetails'
import { getAddress } from 'sr/utils/api/individual/address/getAddress'
import { useDispatch, useSelector } from 'react-redux'
import { fetchIndividual } from 'sr/redux/reducers/individual'
 const LocationForm: ForwardRefRenderFunction<any, any> = ({dataAddedHandle=null, id}, ref) => {
    const [addresstype, setAddressType] = useState('')
    const [address, setAddress] = useState()
    const [remark, setRemark] = useState('')
    const [loader, setLoader] = useState(false)
    const [userId, setUserId] = useState<string>()
    const [data, setData] = useState()
    const intl = useIntl()
    const dispatch = useDispatch()
    const userData = useSelector((state:any)=> state.individual.data)
const HandleAutoLocation = (data)=> {
    setAddress(data)
}

useEffect(()=>{
    if(userId){
        if(!userData){
fetchIndividual({id:userId})
        }
    }
},[userId])

useEffect(()=> {
const {user_id} = getUserDetails()
setUserId(user_id)
},[])

const InitialValues = {
    address_type:addresstype,
    individual_id:userId,
    address:address,
    remark:remark,
}

const {submitForm, errors} = useFormik({
    initialValues:InitialValues,
    enableReinitialize:true,
    validationSchema:AddressSchema,
    onSubmit:async (values)=> {
        setLoader(true)
      
        
        try {
        
            
            let res
            if(id) {
                res = await updateAddress({id:id, ...values})
            }
            else {
         res = await createAddress(values)
            }
        if(res?.success===true) {
            dataAddedHandle(true)
            if(id){
                SuccessMessage('API.SUCCESS.ADDRESS.UPDATE')
            }else {
            SuccessMessage('API.SUCCESS.ADDRESS.ADD')
            }
        }
        else {
setLoader(false)
        }

        }
        catch(e:any) {
         
setLoader(false)
        }
            
    }
})
React.useImperativeHandle(ref, () => ({
    submitForm,
  }));
  useEffect(()=> {
    const fetchLocation = async (id)=> {
        setLoader(true)
      try {
        const params = new URLSearchParams()
       if (id) params.append('id', id)
      const res = await getAddress(params)
       if(res?.success===true) {
        setRemark(res?.data?.remark)
    
        setData(res?.data?.address)
        setAddressType(res?.data?.address_type)
        setRemark(res?.data?.remark)
        setLoader(false)
       }
       else {
      setLoader(false)
       }
      }
      catch(e:any) {
        setLoader(false)
      }
      }
      if(id) {
        fetchLocation(id)
      }
  },[id])

  return (

    <form>
        {loader &&<LoaderFullScreen></LoaderFullScreen> }
                <AutoLocation  HandleAutoLocation={HandleAutoLocation} address={data}></AutoLocation>
                            
                <div className='mt-10'>
                <label  htmlFor="Remarks" className=" mb-2 text-sm  flex items-center"><FormattedMessage id="INDIVIDUAL.MANAGE.ADDRESSES.INPUT.REMARKS" defaultMessage="Remarks" /></label>
<TextArea 
value={remark}
divClassName=""
placeholder={intl.formatMessage({id:'INDIVIDUAL.MANAGE.ADDRESSES.INPUT.REMARKS.PLACEHOLDER', defaultMessage:'Write your note here...'})} 
className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:border-[#0078ae] focus:shadow-inputshadow outline-0" 
onChange={(e)=> setRemark(e.target.value)}  
id="Remarks" rows={4}></TextArea>
</div>              
                </form>
  )
}
export default forwardRef(LocationForm)